/* Native top-layer modal: Escape, focus containment and a no-JS contact fallback. */
if (!customElements.get('hatchill-size-guide')) {
  customElements.define('hatchill-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      const button = this.querySelector('[data-size-guide-open]');
      const dialog = this.querySelector('dialog');
      const contact = this.querySelector('[data-fit-contact]');
      if (!button || !dialog?.showModal) return;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      button.hidden = false;
      contact.hidden = true;
      button.addEventListener('click', () => {
        if (!dialog.open) dialog.showModal();
      }, options);
      this.querySelector('[data-size-guide-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        if (button.isConnected) button.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      this.querySelector('dialog[open]')?.close();
      this.listeners?.abort();
      this.listeners = null;
    }
  });
}
